import { useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../api";
import { Reveal } from "../components/Reveal";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      toast.success("Your note is on its way — we reply within two working days.");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err, "Could not send your message."));
    } finally {
      setBusy(false);
    }
  };

  const field =
    "w-full rounded-2xl border border-sage/20 bg-white/80 px-5 py-3.5 text-sm text-ink outline-none transition-colors placeholder:text-ink/35 focus:border-sage";

  return (
    <div className="mx-auto max-w-2xl px-6 py-16 md:px-8 lg:py-24" data-testid="contact-page">
      <Reveal>
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-sage">Say hello</p>
        <h1 className="mt-3 font-serif text-4xl font-light tracking-tight text-ink sm:text-5xl">
          Write to the studio
        </h1>
        <p className="mt-5 text-base font-light leading-relaxed text-ink/65">
          Questions about a download, a licence, or a custom request? Leave a note and the studio
          will reply by email.
        </p>
        <form onSubmit={submit} className="mt-10 space-y-5">
          <input
            data-testid="contact-name-input"
            required
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            placeholder="Your name"
            className={field}
          />
          <input
            data-testid="contact-email-input"
            required
            type="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            placeholder="Your email"
            className={field}
          />
          <textarea
            data-testid="contact-message-input"
            required
            rows={6}
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
            placeholder="How can we help?"
            className={field}
          />
          <button
            data-testid="contact-submit-button"
            disabled={busy}
            className="inline-flex items-center gap-3 rounded-full bg-sage px-8 py-4 text-sm font-medium text-cream transition-all duration-300 hover:-translate-y-0.5 hover:bg-sage-deep disabled:opacity-60"
          >
            {busy ? <Loader2 size={16} className="animate-spin" /> : <Send size={15} />}
            Send message
          </button>
        </form>
      </Reveal>
    </div>
  );
}
